import { styled } from 'styles';

export const StyledContainer = styled.div`
  margin: 0 auto;
  max-width: 90rem;
  padding: ${({ theme }) => theme.spacing.absolute.huge};
  width: 100%;

  @media (max-width: 576px) {
    padding: ${({ theme }) => theme.spacing.absolute.larger};
  }
`;

StyledContainer.displayName = 'Container';
